import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import styles from './EmptyPreviewState.module.scss';

interface Props {
	staticTotalPrograms: number;
}

export const EmptyPreviewState: React.FC<Props> = ({ staticTotalPrograms }) => {
	const getProgramText = (staticTotalPrograms: number) => {
		switch (staticTotalPrograms) {
			case 0:
				return 'Search learning programs';
			case 1:
				return 'Search 1 learning program';
			default:
				return `Search ${staticTotalPrograms} learning programs`;
		}
	};

	return (
		<div className={styles.emptyContainer}>
			<div className={styles.textGroup}>
				<Typography variant='h2'>{getProgramText(staticTotalPrograms)}</Typography>
				<Typography variant='body1'>Or pick from suggested searches</Typography>
			</div>
		</div>
	);
};
